import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  wrapper: {
    base: {
      width: '100%',
      minHeight: '60px',
    },
    'size-small': {
      minHeight: '40px',
    },
  },

  list: {
    base: {
      padding: `0 ${theme.settings.spacing.small}`,
      margin: 0,
      whiteSpace: 'nowrap',
    },
    'size-small': { padding: 0 },
  },

  item: {
    base: {
      ...theme.typography.body,
      display: 'inline-block',
      position: 'relative',
      listStyle: 'none',
    },

    active: {
      color: theme.colors.accents.primary,

      ':hover': {
        color: theme.colors.accents.primaryHover,
      },
    },
  },

  moreItem: {
    normal: {
      ':hover': {
        color: theme.colors.text.normal,
      },
    },

    active: {
      color: theme.colors.text.normal,

      ':hover': {
        color: theme.colors.text.normal,
      },
    },
  },

  moreLabel: {
    base: {
      position: 'relative',
      display: 'block',
      textDecoration: 'none',
      backgroundColor: 'inherit',
      border: 'none',
      fontWeight: theme.settings.typography.weights.medium,
      padding: theme.settings.spacing.large,
      color: theme.colors.accents.secondary,
      lineHeight: '20px',
      maxHeight: '60px',
      cursor: 'pointer',

      '.intent-mouse &:focus': {
        outline: 'none',
      },

      ':hover': {
        color: theme.colors.accents.secondaryHover,
      },

      ':focus': {
        outlineOffset: '-5px',
      },
    },

    'size-small': {
      padding: `12px ${theme.settings.spacing.small}`,
    },
  },

  itemLabel: {
    base: {
      position: 'relative',
      display: 'block',
      cursor: 'default',
      textDecoration: 'none',
      backgroundColor: 'inherit',
      border: 'none',
      fontWeight: theme.settings.typography.weights.medium,
      padding: theme.settings.spacing.large,
      color: theme.colors.accents.secondary,
      opacity: 0.5,
      lineHeight: '20px',
      maxHeight: '60px',

      '.intent-mouse &:focus': {
        outline: 'none',
      },
    },

    'size-small': {
      padding: `12px ${theme.settings.spacing.small}`,
      maxHeight: '40px',
    },

    clickable: {
      cursor: 'pointer',
      opacity: 1,

      ':hover': {
        color: theme.colors.accents.secondaryHover,
        textDecoration: 'none',
      },

      ':active': {
        color: theme.colors.text.normalActive,
        textDecoration: 'none',
      },

      ':focus': {
        outlineOffset: '-5px',
      },
    },

    active: {
      color: theme.colors.accents.primary,
      opacity: 1,

      ':focus': {
        textDecoration: 'none',
      },

      ':hover': {
        color: theme.colors.accents.primary,
      },

      ':active': {
        color: theme.colors.accents.primary,
      },
    },
  },

  itemActiveBar: {
    base: {
      position: 'absolute',
      bottom: 0,
      left: theme.settings.spacing.large,
      right: theme.settings.spacing.large,
      height: '2px',
      backgroundColor: theme.colors.accents.primary,
    },

    moreList: {
      // With these last 5px only since it looks good
      // (with the icon bounding box being about 5px)
      right: 'calc(theme.settings.spacing.large + 5px)',
    },

    'size-small': {
      left: 0,
      right: 0,
    },
  },

  chevronIcon: {
    base: {
      display: 'inline-block',
      width: '20px',
      height: '20px',
      verticalAlign: 'top',
      marginTop: '-2px',
    },
  },

  chevronIconPath: {
    normal: {
      fill: theme.colors.text.normal,
    },

    active: {
      fill: theme.colors.accents.primary,
    },
  },

  dropdown: {
    base: {
      minWidth: '220px',
      listStyle: 'none',
      padding: '0px',
    },
  },

  dropdownItem: {
    base: {
      display: 'block',
      alignItems: 'center',
      width: '100%',
      paddingTop: theme.settings.spacing.small,
      paddingRight: theme.settings.spacing.medium,
      paddingBottom: theme.settings.spacing.small,
      paddingLeft: theme.settings.spacing.medium,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      backgroundColor: 'white',
      cursor: 'pointer',
      appearance: 'none',
      border: 'none',
      textAlign: 'left',

      '.intent-mouse &:focus': {
        outline: 'none',
      },

      ':focus': {
        outlineOffset: '-5px',
      },

      ...theme.typography.body,
    },
  },
})
